import { PropertyType as SrsPropertyType } from 'srs-middleware';
import { filterProperties } from 'utilities/srsUtils';
import { choropleth } from 'widgets/endpoints';
import { ChoroplethMapWrapper } from './components/ChoroplethMapWrapper';
import { ChoroplethMapWidget } from './components/ChoroplethMapWidget';
import { ChoroplethMapKnobs } from './components/ChoroplethMapKnobs';

const types = [SrsPropertyType.GeoPoint];

export const config = {
	key: 'CHOROPLETH_MAP',
	label: 'Choropleth Map',
	icon: 'globe',
	widget: ChoroplethMapWidget,
	wrapper: ChoroplethMapWrapper,
	endpoint: choropleth,
	Knobs: ChoroplethMapKnobs,
	types: types,
	createDefaultOptions: (filteredProperties) => {
		const rtn = {
			options: {
				parameters: {
					MaxValues: 10000,
				},
				propertyList: filteredProperties?.map((prop) => prop.name),
			},
		};
		return rtn;
	},
	createDefaultConfiguration: (_filteredProperties) => {
		return {
			mapStyle: 'light-v10',
			markerColor: '#003467',
			fitToPoints: false,
			colorScale: 'Auto',
			tileServer: 'mapbox://styles/mapbox/',
			mapboxAPIKey: 'pk.eyJ1IjoiYWRkeW1vcmFuIiwiYSI6ImNrZGkweG9vZDAwaDgyem51OGYwMm15cTYifQ.C0GhL0ddaZtJD6Z3RIEh7Q',
		};
	},
	isValid: (selectedDefinitionName) => {
		return filterProperties(selectedDefinitionName, [], types).length >= 1;
	},
};
